var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.absoluteUrl)?_c((_vm.dynamic && !_vm.areRoutesRegistered()) ? 'div' : 'router-link',_vm._g(_vm._b({tag:"component"},'component',Object.assign({}, {to: _vm.destination.location,
        tag: _vm.tag,
        dynamic: _vm.dynamic},
        _vm.$attrs),false),_vm.$listeners),[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.absoluteUrl}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }